import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

const ua = navigator.userAgent || "";
const isIOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
const isMobile = isIOS || /Android|Mobi/i.test(ua);

function saveBlob(url, filename) {
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
}

// iOS: apre il PDF in una nuova scheda (da li si stampa/condivide/salva). La finestra va aperta subito al click.
async function openPdfIOS(path) {
  const w = window.open("", "_blank");
  const res = await api.get(path, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  if (w) w.location.href = url;
  else window.location.href = url;
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
}

export async function downloadPdf(path, filename) {
  if (isIOS) return openPdfIOS(path);
  const res = await api.get(path, { responseType: "blob" });
  saveBlob(window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" })), filename);
}

export async function printPdf(path) {
  if (isIOS) return openPdfIOS(path);
  if (isMobile) return downloadPdf(path, `${path.split("/").filter(Boolean).slice(-3).join("_")}.pdf`);
  const res = await api.get(path, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.right = "0";
  iframe.style.bottom = "0";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "0";
  iframe.src = url;
  iframe.onload = () => {
    setTimeout(() => {
      try {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      } catch (e) {
        window.open(url, "_blank");
      }
    }, 300);
  };
  document.body.appendChild(iframe);
}

export async function downloadFile(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  saveBlob(window.URL.createObjectURL(new Blob([res.data])), filename);
}

export const eur = (v) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(v || 0));

export const titleCase = (s) =>
  (s || "").toLowerCase().replace(/\p{L}[\p{L}'-]*/gu, (w) => w.charAt(0).toUpperCase() + w.slice(1));

// Data YYYY-MM-DD in ora italiana da una data ISO (UTC)
export const romeDay = (iso) => {
  if (!iso) return "";
  if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) return iso;
  const d = new Date(iso);
  return isNaN(d) ? String(iso).slice(0, 10) : d.toLocaleDateString("sv-SE", { timeZone: "Europe/Rome" });
};

export const PAYMENT_METHODS = ["contanti", "bancomat", "bonifico", "finanziamento_compass", "finanziamento_klarna", "carta_docente", "sospeso"];
export const EXPENSE_METHODS = ["contanti", "bancomat", "bonifico", "finanziamento_compass", "finanziamento_klarna", "carta_docente"];

const METHOD_LABELS = {
  contanti: "Contanti", bancomat: "Bancomat", bonifico: "Bonifico",
  finanziamento_compass: "Finanziamento Compass", finanziamento_klarna: "Finanziamento Klarna",
  carta_docente: "Carta del Docente", sospeso: "Sospeso", finanziamento: "Finanziamento",
  finanziamento_karma: "Finanziamento Klarna", storico: "Storico", misto: "Combinato",
};
export const methodLabel = (m) => METHOD_LABELS[m] || m;

export default api;
export { API };
